import React from 'react';
import FieldDecorator, {FieldDecoratorProps} from './FieldDecorator';

import './TextInput.less';

type OwnProps = Omit<React.HTMLProps<HTMLInputElement>, 'onChange' | 'label'> & {
	onChange: (value: string) => void;
};

type Props = OwnProps & FieldDecoratorProps;

const TextInput = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
	const {onChange, ...rest} = props;

	function handleChange(e: React.SyntheticEvent<HTMLInputElement>) {
		onChange((e.target as HTMLInputElement).value);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const {label, ...inputProps} = rest;
	return (
		<FieldDecorator {...rest}>
			<input {...inputProps} ref={ref} onChange={handleChange} />
		</FieldDecorator>
	);
});

export default TextInput;
